
import { Card } from './types';

/**
 * Starter units - hero-specific starting cards.
 */
export const starterUnits: Card[] = [
  // Guitar Teacher starters
  {
    "id": "starter_beginner_student",
    "name": "Principiante",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 1,
    "attack": 2,
    "health": 1,
    "text": "Summon: If your hero power buffs units, this gains +1 Attack.",
    "tags": ["starter", "booster"],
    "starterForHeroId": "guitar_teacher",
    "abilities": [{ "id": "buff_self_if_hero_buffs_units", "trigger": "summon", "params": { "attack": 1, "health": 0 } }]
  },
  {
    "id": "starter_practice_amp",
    "name": "Ampli de Ensayo",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 1,
    "attack": 0,
    "health": 3,
    "text": "Aura: Your other units have +1 Attack this combat.",
    "tags": ["starter", "support", "booster"],
    "starterForHeroId": "guitar_teacher",
    "abilities": [{ "id": "aura_buff_other_units_combat", "trigger": "start_of_combat", "params": { "attack": 1, "health": 0 } }]
  },
  {
    "id": "starter_rookie_riffer",
    "name": "El Riffero Morro",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 1,
    "attack": 1,
    "health": 2,
    "text": "Whenever you buy a unit, gain +1 Attack this combat.",
    "tags": ["starter", "booster"],
    "starterForHeroId": "guitar_teacher",
    "abilities": [{ "id": "buff_self_on_buy", "trigger": "on_buy", "params": { "attack": 1, "health": 0 } }]
  },

  // Audio Guy starters
  {
    "id": "starter_stage_shield",
    "name": "Escudo de Escena",
    "faction": "emo",
    "tribe": "la_tocada",
    "tier": 1,
    "attack": 0,
    "health": 4,
    "text": "Summon: Give a friendly unit +1 Health.",
    "tags": ["starter", "booster"],
    "starterForHeroId": "audio_guy",
    "abilities": [{ "id": "buff_friendly_permanent", "trigger": "summon", "params": { "attack": 0, "health": 1 } }]
  },
  {
    "id": "starter_sound_tech_apprentice",
    "name": "Asistente de Sonido",
    "faction": "emo",
    "tribe": "la_tocada",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "The first time this takes damage each combat, reduce that damage by 1.",
    "tags": ["starter", "booster"],
    "starterForHeroId": "audio_guy",
    "abilities": [{ "id": "reduce_damage_taken", "trigger": "passive", "params": { "amount": 1, "firstHitOnly": true } }]
  },
  {
    "id": "starter_cheap_earplugs",
    "name": "Tapones Baratos",
    "faction": "emo",
    "tribe": "la_tocada",
    "tier": 1,
    "attack": 1,
    "health": 1,
    "text": "Summon: Give your leftmost unit +2 Health this combat.",
    "tags": ["starter", "booster"],
    "starterForHeroId": "audio_guy",
    "abilities": [{ "id": "buff_leftmost_unit_combat", "trigger": "summon", "params": { "attack": 0, "health": 2 } }]
  },

  // Club Owner starters
  {
    "id": "starter_backstage_passer",
    "name": "Pase de Backstage",
    "faction": "emo",
    "tribe": "anclas",
    "tier": 1,
    "attack": 2,
    "health": 2,
    "text": "The first time you refresh the shop each turn, it costs 0.",
    "tags": ["starter", "economy", "booster"],
    "starterForHeroId": "club_owner",
    "abilities": [{ "id": "grant_free_refresh", "trigger": "passive", "params": { "count": 1 } }]
  },
  {
    "id": "starter_local_band_member",
    "name": "Músico Local",
    "faction": "emo",
    "tribe": "anclas",
    "tier": 1,
    "attack": 1,
    "health": 2,
    "text": "Summon: Discover a unit from your chosen tribe.",
    "tags": ["starter", "tribe", "booster"],
    "starterForHeroId": "club_owner",
    "abilities": [{ "id": "discover_unit", "trigger": "summon", "params": { "tribe": "self", "tier": 2 } }]
  },
  {
    "id": "starter_regular_at_the_venue",
    "name": "Regular del Foro",
    "faction": "emo",
    "tribe": "anclas",
    "tier": 1,
    "attack": 3,
    "health": 1,
    "text": "At the start of combat, if the shop contains a unit from your main tribe, gain +1 Attack.",
    "tags": ["starter", "booster"],
    "starterForHeroId": "club_owner",
    "abilities": [{ "id": "buff_self_if_shop_has_tribe", "trigger": "end_of_turn", "params": { "tribe": "self", "attack": 1, "health": 0 } }]
  },

  // Piercing Artist starters
  {
    "id": "starter_fresh_ink_trainee",
    "name": "De la Tinta Fresca",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "Summon: Give a friendly unit +1/+1 permanently.",
    "tags": ["starter", "buff", "booster"],
    "starterForHeroId": "piercing_artist",
    "abilities": [{ "id": "buff_friendly_permanent", "trigger": "summon", "params": { "attack": 1, "health": 1 } }]
  },
  {
    "id": "starter_steady_hand_apprentice",
    "name": "Mano Firme",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 1,
    "attack": 2,
    "health": 2,
    "text": "After this survives a combat, gain +1/+1 permanently.",
    "tags": ["starter", "scaling", "booster"],
    "starterForHeroId": "piercing_artist",
    "abilities": [{ "id": "buff_self_after_combat", "trigger": "after_combat_survives", "params": { "attack": 1, "health": 1 } }]
  },
  {
    "id": "starter_metal_collector",
    "name": "Coleccionista de Metal",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 1,
    "attack": 2,
    "health": 1,
    "text": "Permanent buffs on this unit are doubled.",
    "tags": ["starter", "scaling", "booster"],
    "starterForHeroId": "piercing_artist",
    "abilities": [{ "id": "amplify_permanent_buffs", "trigger": "passive", "params": { "multiplier": 2 } }]
  },

  // Old School Punk starters
  {
    "id": "starter_pit_starter",
    "name": "Moshero",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 1,
    "attack": 2,
    "health": 1,
    "text": "This unit always attacks first.",
    "tags": ["starter", "initiative", "booster"],
    "starterForHeroId": "old_school_punk",
    "flags": { "firstStrike": true }
  },
  {
    "id": "starter_boot_stomper",
    "name": "Pisoteador",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "When this attacks first, deal 1 damage to the next enemy in line.",
    "tags": ["starter", "initiative", "booster"],
    "starterForHeroId": "old_school_punk",
    "abilities": [{ "id": "damage_behind_target", "trigger": "on_first_attack", "params": { "amount": 1 } }]
  },
  {
    "id": "starter_circle_veteran",
    "name": "Veterano del Circle",
    "faction": "emo",
    "tribe": "slameros",
    "tier": 1,
    "attack": 2,
    "health": 2,
    "text": "If this is the first unit to attack in a combat, gain +1/+1 permanently.",
    "tags": ["starter", "scaling", "booster"],
    "starterForHeroId": "old_school_punk",
    "abilities": [{ "id": "buff_self_on_first_attack", "trigger": "on_first_attack", "params": { "attack": 1, "health": 1 } }]
  },

  // Indie DJ starters
  {
    "id": "starter_record_collector",
    "name": "Vinilero",
    "faction": "emo",
    "tribe": "la_tocada",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "Summon: Give a random unit in the shop +1/+1.",
    "tags": ["starter", "shop", "booster"],
    "starterForHeroId": "indie_dj",
    "abilities": [{ "id": "buff_random_shop", "trigger": "summon", "params": { "attack": 1, "health": 1 } }]
  },
  {
    "id": "starter_vinyl_hoarder",
    "name": "Acumulador de Vinilos",
    "faction": "emo",
    "tribe": "la_tocada",
    "tier": 1,
    "attack": 2,
    "health": 2,
    "text": "Whenever you refresh the shop, gain +1 Attack this combat.",
    "tags": ["starter", "shop", "booster"],
    "starterForHeroId": "indie_dj",
    "abilities": [{ "id": "buff_self_for_combat", "trigger": "on_buy", "params": { "attack": 1, "health": 0 } }]
  },
  {
    "id": "starter_beat_tuner",
    "name": "Afinador de Ritmo",
    "faction": "emo",
    "tribe": "la_tocada",
    "tier": 1,
    "attack": 1,
    "health": 2,
    "text": "Once per turn, your first shop refresh costs 0.",
    "tags": ["starter", "economy", "booster"],
    "starterForHeroId": "indie_dj",
    "abilities": [{ "id": "grant_free_refresh", "trigger": "passive", "params": { "count": 1 } }]
  },

  // Scene Guardian starters
  {
    "id": "starter_snack_provider",
    "name": "Proveedor de Refrescos",
    "faction": "emo",
    "tribe": "anclas",
    "tier": 1,
    "attack": 1,
    "health": 2,
    "text": "Last Breath: Heal your hero for 1.",
    "tags": ["starter", "healing", "booster"],
    "starterForHeroId": "scene_guardian",
    "abilities": [{ "id": "heal_hero_on_death", "trigger": "lastbreath", "params": { "amount": 1 } }]
  },
  {
    "id": "starter_hydration_mentor",
    "name": "De las Aguas Frescas",
    "faction": "emo",
    "tribe": "anclas",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "Whenever a friendly unit dies, gain +1 Health this combat.",
    "tags": ["starter", "defensive", "booster"],
    "starterForHeroId": "scene_guardian",
    "abilities": [{ "id": "buff_self_on_friendly_death", "trigger": "on_friendly_death", "params": { "attack": 0, "health": 1 } }]
  },
  {
    "id": "starter_volunteer_guardian",
    "name": "Voluntario Guardián",
    "faction": "emo",
    "tribe": "anclas",
    "tier": 1,
    "attack": 2,
    "health": 2,
    "text": "Summon: Heal your hero for 2.",
    "tags": ["starter", "healing", "booster"],
    "starterForHeroId": "scene_guardian",
    "abilities": [{ "id": "heal_hero_battlecry", "trigger": "summon", "params": { "amount": 2 } }]
  },

  // Local Promoter starters
  {
    "id": "starter_flyer_distributor",
    "name": "Distribuidor de Volantes",
    "faction": "emo",
    "tribe": "anclas",
    "tier": 1,
    "attack": 2,
    "health": 1,
    "text": "Every second turn, gain +1/+1.",
    "tags": ["starter", "scaling", "booster"],
    "starterForHeroId": "local_promoter",
    "abilities": [{ "id": "buff_self_every_nth_turn", "trigger": "start_of_turn", "params": { "period": 2, "attack": 1, "health": 1 } }]
  },
  {
    "id": "starter_hype_intern",
    "name": "Pasante del Hype",
    "faction": "emo",
    "tribe": "anclas",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "At the start of your turn, give a random unit in the shop +1 Health.",
    "tags": ["starter", "shop", "booster"],
    "starterForHeroId": "local_promoter",
    "abilities": [{ "id": "buff_random_shop", "trigger": "start_of_turn", "params": { "attack": 0, "health": 1 } }]
  },
  {
    "id": "starter_zine_writer",
    "name": "Zineador",
    "faction": "emo",
    "tribe": "anclas",
    "tier": 1,
    "attack": 1,
    "health": 2,
    "text": "End of turn: give a random unit in the shop +1/+1. Freeze to keep it.",
    "tags": ["starter", "shop", "booster"],
    "starterForHeroId": "local_promoter",
    "abilities": [{ "id": "buff_random_shop", "trigger": "end_of_turn", "params": { "attack": 1, "health": 1 } }]
  },

  // OG Homie starters
  {
    "id": "starter_little_homie",
    "name": "Morrito",
    "faction": "cholo",
    "tribe": "bajitos",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "If this is your leftmost frontline unit, gain +1 Health.",
    "tags": ["starter", "frontline", "booster"],
    "starterForHeroId": "og_hommie",
    "abilities": [{ "id": "buff_self_if_leftmost", "trigger": "start_of_combat", "params": { "attack": 0, "health": 1 } }]
  },
  {
    "id": "starter_barrio_shield",
    "name": "Defensa del Barrio",
    "faction": "cholo",
    "tribe": "bajitos",
    "tier": 1,
    "attack": 0,
    "health": 4,
    "text": "The unit behind this takes 1 less damage the first time it is hit each combat.",
    "tags": ["starter", "tank", "booster"],
    "starterForHeroId": "og_hommie",
    "abilities": [{ "id": "reduce_damage_behind", "trigger": "passive", "params": { "amount": 1, "firstHitOnly": true } }]
  },
  {
    "id": "starter_corner_guard",
    "name": "Guardián de Esquina",
    "faction": "cholo",
    "tribe": "bajitos",
    "tier": 1,
    "attack": 2,
    "health": 2,
    "text": "The first time this takes damage each combat, gain +2 Health.",
    "tags": ["starter", "frontline", "booster"],
    "starterForHeroId": "og_hommie",
    "abilities": [{ "id": "buff_self_on_first_damage", "trigger": "on_take_damage", "params": { "attack": 0, "health": 2 } }]
  },

  // Lowrider Mechanic starters
  {
    "id": "starter_custom_tire_kid",
    "name": "Chamaco de Aros",
    "faction": "cholo",
    "tribe": "bajitos",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "Whenever this is buffed, 50% chance to double that buff.",
    "tags": ["starter", "scaling", "booster"],
    "starterForHeroId": "lowrider_mechanic",
    "abilities": [{ "id": "amplify_permanent_buffs", "trigger": "passive", "params": { "multiplier": 2, "chance": 0.5 } }]
  },
  {
    "id": "starter_chrome_polisher",
    "name": "Pulidor de Cromo",
    "faction": "cholo",
    "tribe": "bajitos",
    "tier": 1,
    "attack": 2,
    "health": 1,
    "text": "Whenever this gains Attack or Health, also gain +1 Health.",
    "tags": ["starter", "buff", "booster"],
    "starterForHeroId": "lowrider_mechanic",
    "abilities": [{ "id": "bonus_on_gain_stats", "trigger": "passive", "params": { "health": 1 } }]
  },
  {
    "id": "starter_upgrade_assistant",
    "name": "Asistente de Upgrades",
    "faction": "cholo",
    "tribe": "bajitos",
    "tier": 1,
    "attack": 1,
    "health": 2,
    "text": "Summon: Give a random friendly unit +1/+1.",
    "tags": ["starter", "buff", "booster"],
    "starterForHeroId": "lowrider_mechanic",
    "abilities": [{ "id": "buff_random_friendly", "trigger": "summon", "params": { "attack": 1, "health": 1 } }]
  },

  // Barrio Godfather starters
  {
    "id": "starter_young_lieutenant",
    "name": "Teniente Joven",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 2,
    "health": 2,
    "text": "Counts as two units of its tribe for tribe bonuses.",
    "tags": ["starter", "tribe", "booster"],
    "starterForHeroId": "barrio_godfather",
    "abilities": [{ "id": "counts_as_two_for_tribe", "trigger": "passive", "params": { "weight": 2 } }]
  },
  {
    "id": "starter_crew_recruiter",
    "name": "Reclutador de Cuadra",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "Summon: Discover a unit of your chosen tribe.",
    "tags": ["starter", "tribe", "booster"],
    "starterForHeroId": "barrio_godfather",
    "abilities": [{ "id": "discover_unit", "trigger": "summon", "params": { "tribe": "self", "tier": 2 } }]
  },
  {
    "id": "starter_neighborhood_organizer",
    "name": "Organizador de Fiesta",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 2,
    "health": 1,
    "text": "Whenever you play your third unit in a turn, gain +1/+1.",
    "tags": ["starter", "tempo", "booster"],
    "starterForHeroId": "barrio_godfather",
    "abilities": [{ "id": "buff_self_if_played_enough", "trigger": "summon", "params": { "count": 3, "attack": 1, "health": 1 } }]
  },

  // Tattoo Master starters
  {
    "id": "starter_ink_apprentice",
    "name": "Aprendiz de Placas",
    "faction": "cholo",
    "tribe": "plaqueros",
    "tier": 1,
    "attack": 1,
    "health": 4,
    "text": "After each combat, gain +1 Health permanently.",
    "tags": ["starter", "tank", "booster"],
    "starterForHeroId": "tattoo_master",
    "abilities": [{ "id": "buff_self_after_combat", "trigger": "after_combat_survives", "params": { "attack": 0, "health": 1 } }]
  },
  {
    "id": "starter_skin_artist",
    "name": "Artista de Piel",
    "faction": "cholo",
    "tribe": "plaqueros",
    "tier": 1,
    "attack": 2,
    "health": 3,
    "text": "Permanent buffs to this unit are increased by 50%.",
    "tags": ["starter", "scaling", "booster"],
    "starterForHeroId": "tattoo_master",
    "abilities": [{ "id": "amplify_permanent_buffs", "trigger": "passive", "params": { "multiplier": 1.5 } }]
  },
  {
    "id": "starter_spirit_protector",
    "name": "Protectora Espiritual",
    "faction": "cholo",
    "tribe": "plaqueros",
    "tier": 1,
    "attack": 0,
    "health": 5,
    "text": "Cannot attack. Adjacent units have +1 Health.",
    "tags": ["starter", "support", "booster"],
    "starterForHeroId": "tattoo_master",
    "flags": { "cannotAttack": true },
    "abilities": [{ "id": "aura_buff_adjacent_health", "trigger": "start_of_combat", "params": { "attack": 0, "health": 1 } }]
  },

  // Neighborhood Watcher starters
  {
    "id": "starter_lookout",
    "name": "Mirón",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 1,
    "health": 2,
    "text": "Start of combat: Inspect the enemy leftmost unit and gain +1 Attack.",
    "tags": ["starter", "scout", "booster"],
    "starterForHeroId": "neighborhood_watcher",
    "abilities": [{ "id": "buff_self_start_of_combat", "trigger": "start_of_combat", "params": { "attack": 1, "health": 0 } }]
  },
  {
    "id": "starter_street_watch_kid",
    "name": "Chavalo de la Ronda",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 2,
    "health": 1,
    "text": "Start of combat: swap places with the ally in front of it.",
    "tags": ["starter", "positioning", "booster"],
    "starterForHeroId": "neighborhood_watcher",
    "abilities": [{ "id": "swap_with_left", "trigger": "start_of_combat", "params": {} }]
  },
  {
    "id": "starter_alert_guard",
    "name": "Guardián Alerta",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "Start of combat: If the enemy frontliner has less Health than this, gain +2 Attack.",
    "tags": ["starter", "positioning", "booster"],
    "starterForHeroId": "neighborhood_watcher",
    "abilities": [{ "id": "buff_self_if_enemy_frontliner_weaker", "trigger": "start_of_combat", "params": { "attack": 2, "health": 0 } }]
  },

  // Street Barber starters
  {
    "id": "starter_clipper_kid",
    "name": "Mochila",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 2,
    "health": 1,
    "text": "Whenever its stats are swapped, gain +1 Health.",
    "tags": ["starter", "swap", "booster"],
    "starterForHeroId": "street_barber",
    "abilities": [{ "id": "bonus_on_stats_swapped", "trigger": "passive", "params": { "attack": 0, "health": 1 } }]
  },
  {
    "id": "starter_fade_specialist",
    "name": "Especialista del Fade",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "Once per combat: At start of combat, swap this unit's Attack and Health.",
    "tags": ["starter", "swap", "booster"],
    "starterForHeroId": "street_barber",
    "abilities": [{ "id": "swap_attack_health_combat", "trigger": "start_of_combat", "params": {} }]
  },
  {
    "id": "starter_blade_dancer",
    "name": "Tijera",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 1,
    "health": 2,
    "text": "If this unit's Attack is greater than its Health at start of combat, gain +1 Attack.",
    "tags": ["starter", "swap", "booster"],
    "starterForHeroId": "street_barber",
    "abilities": [{ "id": "buff_self_if_attack_greater_health", "trigger": "start_of_combat", "params": { "attack": 1, "health": 0 } }]
  },

  // Old School Writer starters
  {
    "id": "starter_tagger_apprentice",
    "name": "Aprendiz de Placas",
    "faction": "cholo",
    "tribe": "plaqueros",
    "tier": 1,
    "attack": 1,
    "health": 1,
    "text": "Whenever this deals damage, gain +1/+1 permanently.",
    "tags": ["starter", "scaling", "booster"],
    "starterForHeroId": "old_school_writer",
    "abilities": [{ "id": "buff_self_on_deal_damage", "trigger": "on_deal_damage", "params": { "attack": 1, "health": 1 } }]
  },
  {
    "id": "starter_spray_can_carrier",
    "name": "Portador de Spray",
    "faction": "cholo",
    "tribe": "plaqueros",
    "tier": 1,
    "attack": 2,
    "health": 1,
    "text": "The first time it attacks each combat, this unit attacks first.",
    "tags": ["starter", "initiative", "booster"],
    "starterForHeroId": "old_school_writer",
    "flags": { "firstStrike": true }
  },
  {
    "id": "starter_wall_artist",
    "name": "Artista de Muros",
    "faction": "cholo",
    "tribe": "plaqueros",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "Whenever a friendly unit gains permanent stats, gain +1 Attack.",
    "tags": ["starter", "scaling", "booster"],
    "starterForHeroId": "old_school_writer",
    "abilities": [{ "id": "watch_friendly_gain_stats", "trigger": "passive", "params": { "attack": 1, "health": 0 } }]
  },

  // Block Chef starters
  {
    "id": "starter_meal_prepper",
    "name": "Preparador de la Junta",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 1,
    "health": 3,
    "text": "End of turn: Give a random friendly unit +1 Health.",
    "tags": ["starter", "healing", "booster"],
    "starterForHeroId": "block_chef",
    "abilities": [{ "id": "buff_random_end_of_turn", "trigger": "end_of_turn", "params": { "attack": 0, "health": 1 } }]
  },
  {
    "id": "starter_pan_master",
    "name": "Maestra de Comal",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 2,
    "health": 2,
    "text": "After each combat, heal this for 1.",
    "tags": ["starter", "sustain", "booster"],
    "starterForHeroId": "block_chef",
    "abilities": [{ "id": "heal_self_after_combat", "trigger": "after_combat_survives", "params": { "amount": 1 } }]
  },
  {
    "id": "starter_gathering_helper",
    "name": "Ayudante de Fiestas",
    "faction": "cholo",
    "tribe": "la_clica",
    "tier": 1,
    "attack": 0,
    "health": 4,
    "text": "Whenever a friendly unit gains Health, gain +1 Attack.",
    "tags": ["starter", "scaling", "booster"],
    "starterForHeroId": "block_chef",
    "abilities": [{ "id": "watch_friendly_gain_stats", "trigger": "passive", "params": { "attack": 1, "health": 0, "requires": "health" } }]
  }
];
